import api from "@/api/axios/axios.js";

export async function getAudio(id) {
    try {
        const resp = await api.get(`/login/data/audio/${id}/`);
        console.log("osvaa",resp)
        return resp.data
    } catch (error) {
        return "No hay aun archivo"
    }
}
export async function getTrans(id) {
    try {
        const resp = await api.get(`/login/data/transcripcion/${id}/`);
        console.log("OSVAAA", resp)
        return resp.data
    } catch (error) {
        return "No hay transcripcion"
    }
}

// Actualiza (guarda) el texto editado de la transcripcion en BD.
// Contrato backend: POST /login/data/transcripcion/editar/
//   body: { proyecto, texto }
//   respuesta: { message, sin_cambios, guion_invalidado, aviso, respaldo,
//                caracteres_antes, caracteres_despues }
export async function editarTranscripcion(proyecto, texto) {
    const resp = await api.post(`/login/data/transcripcion/editar/`, {
        proyecto,
        texto,
    });
    return resp.data;
}

// Resumen del guion de un proyecto (para el apartado de Historias de Usuario).
// GET /login/data/guion/resumen/<proyecto_id>/
export async function getGuionResumen(id) {
    const resp = await api.get(`/login/data/guion/resumen/${id}/`);
    return resp.data;
}
// SOLO extrae el texto de un documento (.txt, .docx, .pdf). NO debe persistir
// nada en el store de transcripcion (la persistencia de historia va aparte,
// por guardarTextoHistoria, para que audio y documento no se pisen).
// Contrato esperado del backend: POST /login/extraerTextoDocumento/
//   FormData: { documento: File, Proyecto: id }
//   Respuesta: { texto: "..." }  (o texto plano)
export async function extraerTextoDocumento(id, archivo) {
    const formData = new FormData();
    formData.append("documento", archivo);
    formData.append("Proyecto", id);
    const resp = await api.post(`/login/extraerTextoDocumento/`, formData);
    // Soporta respuesta { texto } o texto plano
    return resp.data?.texto ?? resp.data;
}

// Lee de BD el texto base de la historia de usuario ya guardado.
// Contrato esperado del backend: GET /login/data/historia/texto/{id}/
//   Respuesta: { texto: "..." }  (o texto plano)
export async function getTextoHistoria(id) {
    try {
        const resp = await api.get(`/login/data/historia/texto/${id}/`);
        console.log("EEE", resp)
        if (resp.data?.error) return "";
        
        return resp.data;
    } catch (error) {
        return "";
    }
}

export async function postHistory(id, texto) {
    try {
        const resp = await api.post(`/login/data/history/saved/`, { body: JSON.stringify({ idProyecto: id, contenido: texto }), });
        return resp.data
    } catch (error) {
        return "No hay Historia"
    }

}
export async function postTestCases(id, texto) {
    try {
        const resp = await api.post(`/login/data/testCases/saved/`, { body: JSON.stringify({ idProyecto: id, contenido: texto }), });
        return resp.data
    } catch (error) {
        return "No hay Casos de Prueba"
    }
}

export async function getHistory(id) {
    try {
        var resp = await api.get(`/login/data/history/saved/${id}/`);

        if (resp.data?.error == "No existe historias" || resp.data?.error == "No hay History") {
            resp = {
                data: {
                    data: []
                }
            }
        }
        return resp.data
    } catch (error) {
        console.log("Error en Servicio obtencion Historia".error)
        return error
    }

}
export async function getTestCases(id) {
    try {
        var resp = await api.get(`/login/data/testCases/saved/${id}/`);
        if (resp.data?.error == "No existe Casos de Prueba" || resp.data?.error == "No hay Casos de Prueba") {
            resp = {
                data: {
                    data: []
                }
            }
        }
        return resp.data
    } catch (error) {
        console.log("Error en Servicio obtencion Casos de Prueba".error)
        return error
    }

}
